export default __webpack_public_path__ + "static/media/stickK-plAIground.c7d959d9.png";